import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Cases from '../views/Cases.vue'
import Products from '../views/Products.vue'
import BoomSales from '../views/BoomSales.vue'
import PalmCube from '../views/PalmCube.vue'
import Thanks from '../views/Thanks.vue'
import New from '../views/New.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
   
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/cases',
    name: 'cases',
    component: Cases
  },
  {
    path: '/products',
    name: 'products',
    component: Products
  },
  {
    path: '/boomsales',
    name: 'boomsales',
    component: BoomSales
  },
  {
    path: '/palmcube',
    name: 'palmcube',
    component: PalmCube
  },
  {
    path: '/thanks',
    name: 'thanks',
    component: Thanks
  },
  {
    path: '/new',
    name: 'new',
    component: New
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
